import { Box, Stack } from "@mui/material";
import React from "react";

import { ClickEventType, ParlorDetailProps } from "../../../types";

import { CTypeMainHead } from "../MainHead";
import { ColorSystemProps } from "../../../constants";
import ATypeRegionPriceSummaryItem from "./ATypeRegionPriceSummaryItem";

export function CTypeRegionHead({
  regionParlors,
  sidoName,
  sigunguName,
  expectedParlorPrice,
  mainColor,
  event,
}: {
  regionParlors: Array<ParlorDetailProps>;
  sidoName: string;
  sigunguName?: string;
  expectedParlorPrice: any;
  mainColor: ColorSystemProps;
  event?: ClickEventType;
}) {
  const name = `${sidoName}${sigunguName ? " " + sigunguName : ""}`;
  return (
    <>
      <CTypeMainHead
        title={`${sidoName}${
          sigunguName ? ` ${sigunguName} ` : " "
        }장례식장 추천`}
        sidoName={sidoName}
        sigunguName={sigunguName}
        defaultParlor={regionParlors[0]}
        mainColor={mainColor}
        isRegion
        event={event}
      />

      <Stack gap="6px" padding="40px 20px 20px">
        <Box className="subtitle_18_b">{name} 장례 요약</Box>

        <ATypeRegionPriceSummaryItem
          text="조문객 50명 기준 평균 빈소 비용"
          price={expectedParlorPrice.무빈소장}
        />
        <ATypeRegionPriceSummaryItem
          text="조문객 100명 기준 평균 빈소 비용"
          price={expectedParlorPrice.가족장}
        />
        <ATypeRegionPriceSummaryItem
          text="조문객 200명 기준 평균 빈소 비용"
          price={expectedParlorPrice.일반장}
        />
      </Stack>
    </>
  );
}
